/*
Looking to add a new experiment?
Read this - https://github.com/wix-private/wix-answers/blob/master/answers-client/core/experiments/README.md
*/
export var featureToggleMap = {
    HideInsights: {
        petriSpec: "specs.HideInsights",
        default: false,
        description: "Hides Insights from the app",
        mergeJira: "https://app.asana.com/0/1200368299997249/1205314501501531/f",
    },
    AiGenerateContent: {
        petriSpec: "specs.AiGenerateContent",
        default: false,
        description: "AI generate content in the article page",
        mergeJira: "https://app.asana.com/0/1204064551274092/1204269204191403",
    },
    AiTranslation: {
        petriSpec: "specs.AiTranslation",
        default: false,
        description: "AI translation functionality in article translation mode",
        mergeJira: "https://wix.atlassian.net/browse/CCR-12037",
    },
    SkillBaseRouting: {
        petriSpec: "specs.SkillBaseRouting",
        default: false,
        description: "To display the skills card on the agent modal + required skills on OI info panel",
        mergeJira: "https://app.asana.com/0/1201358638192174/1203058073336995",
    },
    ChannelAvailabilityV2: {
        petriSpec: "specs.ChannelAvailabilityV2",
        default: false,
        description: "Channel availability milestone 2",
        mergeJira: "",
    },
    DisabledAvailableWhenNoChannel: {
        petriSpec: "specs.DisabledAvailableWhenNoChannel",
        default: false,
        description: "Enables feature for disabled available btn for agent subscribed to no channels",
        mergeJira: "https://app.asana.com/0/0/1202835242387247/f",
    },
    ChatTransfer: {
        petriSpec: "specs.ChatTransfer",
        default: false,
        description: "Enables Chat transfer capability",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201920516694870",
    },
    RealTimeViewsCounters: {
        petriSpec: "specs.RealTimeViewsCounters",
        default: false,
        description: "Realtime counters for saved views",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202173716626335/f",
    },
    NewSignatureMenu: {
        petriSpec: "specs.NewSignatureMenu",
        default: false,
        description: "Signature menu on agent menu",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202012744388096/f",
    },
    SlaAssigneeCondition: {
        petriSpec: "specs.SlaAssigneeCondition",
        default: false,
        description: "Displays new SLA assignee condition design",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201889656797600",
    },
    TicketLocaleFilter: {
        petriSpec: "specs.TicketLocaleFilter",
        default: false,
        description: "Add locale filter to ticket filters",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202029962503576",
    },
    SchedulesSLA: {
        petriSpec: "specs.SchedulesSLA",
        default: false,
        description: "Use multiple schedules in SLA Settings",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201811413105632",
    },
    HangupCallAgentNoAnswer: {
        petriSpec: "specs.HangupCallAgentNoAnswer",
        description: "hangup call when participant accepted call but participant's status is NO_ANSWER",
        default: false,
        mergeJira: "https://app.asana.com/0/1201146881163791/1202412057189158/f",
    },
    AutoRoutingFallbackHandler: {
        petriSpec: "specs.AutoRoutingFallbackHandler",
        default: false,
        description: "Add Fallback for AR when duplexer is down",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202040382134584/f",
    },
    SavedFiltersNewApi: {
        petriSpec: "specs.SavedFiltersNewApi",
        default: false,
        description: "Use new API for get saved filters",
        mergeJira: "https://app.asana.com/0/1201324221515881/1201825333398917",
    },
    UpdateSavedFiltersNewApi: {
        petriSpec: "specs.UpdateSavedFiltersNewApi",
        default: false,
        description: "Use new API for update save filters (relevant only for tenants with new brand or locale filter",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202047519187574",
    },
    NewTicketsCountApi: {
        petriSpec: "specs.NewTicketsCountApi",
        default: false,
        description: "use new API for tickets counter",
        mergeJira: "https://app.asana.com/0/1201324218610427/1201739389847273/f",
    },
    categoryCsvImport: {
        petriSpec: "specs.categoryCsvImport",
        default: false,
        description: "Enables Articles CSV Import",
        mergeJira: "no need, its internal",
    },
    BobSnippet: {
        petriSpec: "specs.EnableBobSnippet",
        default: false,
        description: "Will add a new special Bob snippet in call center insights",
        mergeJira: "TBD",
    },
    UseWixRecorder: {
        petriSpec: "specs.UseWixRecorder",
        default: false,
        description: "Enables user session recording",
        mergeJira: "https://jira.wixpress.com/browse/WA-12045",
    },
    WidgetDraggable: {
        petriSpec: "specs.EnableWidgetDraggable",
        default: false,
        description: "Enables Widget V3 draggable feature",
        mergeJira: "https://jira.wixpress.com/browse/WA-9473",
    },
    WidgetIconMsg: {
        petriSpec: "specs.EnableWidgetIconMsg",
        default: false,
        description: "Enables Widget V3 icon msg settings",
        mergeJira: "https://jira.wixpress.com/browse/WA-9615",
    },
    SlaPolicies: {
        petriSpec: "specs.SlaPolicies",
        default: false,
        description: "Enables SLA",
        mergeJira: "https://jira.wixpress.com/browse/WA-9712",
    },
    CustomFields: {
        petriSpec: "specs.CustomFields",
        default: false,
        description: "New Custom Fields Customers / Tickets",
        mergeJira: "https://jira.wixpress.com/browse/WA-9713",
    },
    ChatDevice: {
        petriSpec: "specs.ChatDevice",
        default: false,
        description: "Adds Chat Device to App for AutoAssign feature",
        mergeJira: "https://jira.wixpress.com/browse/WA-9978",
    },
    CallDelay: {
        petriSpec: "specs.CallDelay",
        default: false,
        description: "Enables call delay option for agents",
        mergeJira: "https://jira.wixpress.com/browse/WA-10946",
    },
    CustomFieldsLimit: {
        petriSpec: "specs.CustomFieldsLimit",
        default: false,
        description: "Increases custom fields limits",
        mergeJira: "https://jira.wixpress.com/browse/WA-11019",
    },
    ChatHotkeys: {
        petriSpec: "specs.ChatHotkeys",
        default: false,
        description: "Enables hotkeys for Chat Jira: WA-11436",
        mergeJira: "TBD",
    },
    WhatsappAttachments: {
        petriSpec: "specs.WhatsappAttachments",
        default: false,
        description: "Enables Whatsapp attachments from the App to Whatsapp",
        mergeJira: "TBD - internal",
    },
    RemoveCreditBlock: {
        petriSpec: "specs.RemoveCreditBlock",
        default: false,
        description: "Removes Ticket Page block when credits are insufficient.",
        mergeJira: "https://jira.wixpress.com/browse/WA-12357",
    },
    DashboardOutboundCallsAndTotalTime: {
        petriSpec: "specs.DashboardOutboundCallsAndTotalTime",
        default: false,
        description: 'Patch for outbound sales MH account (and others) to include outbound calls to dashboard without adding filters to the UI. This also adds a "total call time" in the agents table',
        mergeJira: "https://jira.wixpress.com/browse/WA-12295",
    },
    TicketsListNewPresenceComponent: {
        petriSpec: "specs.TicketsListNewPresenceComponent",
        default: false,
        description: "Enables new ticket list presence design",
        mergeJira: "https://jira.wixpress.com/browse/WA-12391",
    },
    EditCategoryIconSrc: {
        petriSpec: "specs.EditCategoryIconSrc",
        default: false,
        description: "Allows editing of category icon by source only, while keeping the icon key. Needed for new HC",
        mergeJira: "https://jira.wixpress.com/browse/WA-12515",
    },
    AnswersEnableChatWebhooksDigibankPOC: {
        petriSpec: "specs.AnswersEnableChatWebhooksDigibankPOC",
        default: false,
        description: "Enables chat webhooks for digibank POC - client and server",
        mergeJira: "https://jira.wixpress.com/browse/WONT-BE-MERGED",
    },
    OneInbox: {
        petriSpec: "specs.OneInbox",
        default: false,
        description: "One Inbox page",
        mergeJira: "https://jira.wixpress.com/browse/WA-12763",
    },
    AdvancedReportsWasabi: {
        petriSpec: "specs.AdvancedReportsWasabi",
        default: false,
        description: "wasabi insights reports",
        mergeJira: "https://jira.wixpress.com/browse/WA-13148",
    },
    CallTypeIndicator: {
        petriSpec: "specs.CallTypeIndicator",
        default: false,
        description: "add a call type column to call center",
        mergeJira: "https://jira.wixpress.com/browse/WA-13463",
    },
    WorkflowsBetaScenarios: {
        petriSpec: "specs.WorkflowsBetaScenarios",
        default: false,
        description: "Opening this experiment enables spotter scenarios that are still in dev",
        mergeJira: "https://jira.wixpress.com/browse/WA-14377",
    },
    OutboundChat: {
        petriSpec: "specs.OutboundChat",
        default: false,
        description: "Enables the option to open an outbound chat",
        mergeJira: "https://jira.wixpress.com/browse/WA-14070",
    },
    ForceHotjarTracking: {
        petriSpec: "specs.ForceHotjarTracking",
        default: false,
        description: "forces hotjar tracking",
        mergeJira: "should never be merged",
    },
    CustomCompanyFieldsFilters: {
        petriSpec: "specs.CustomCompanyFieldsFilters",
        default: false,
        description: "Enables custom company fields in One Inbox Views",
        mergeJira: "https://jira.wixpress.com/browse/WA-14413",
    },
    NewLinesSettingsTable: {
        petriSpec: "specs.NewLinesSettingsTable",
        default: false,
        description: "New line settings table",
        mergeJira: "https://jira.wixpress.com/browse/WA-14635",
    },
    AgentLocaleInterfacePicker: {
        petriSpec: "specs.AgentLocaleInterfacePicker",
        default: false,
        description: "Enables agent locale interface picker from user editor",
        mergeJira: "https://jira.wixpress.com/browse/WA-14721",
    },
    APIReactQuery: {
        petriSpec: "specs.AnswersAPIReactQuery",
        default: false,
        description: "Wraps the API layer with React Query",
        mergeJira: "https://jira.wixpress.com/browse/WA-14859",
    },
    OneInboxCache: {
        petriSpec: "specs.AnswersOneInboxCache",
        default: false,
        description: "Enables the cache layer for OneInbox",
        mergeJira: "https://jira.wixpress.com/browse/WA-15339",
    },
    ChatbotBuilderPOC: {
        petriSpec: "specs.ChatbotBuilderPOC",
        default: false,
        description: "POC of chatbot builder",
        mergeJira: "Wont merge",
    },
    LogDuplexerMessages: {
        petriSpec: "specs.LogDuplexerMessages",
        default: false,
        description: "logs all duplexer messages for debug purposes",
        mergeJira: "https://jira.wixpress.com/browse/WA-15401",
    },
    CallcenterLogs: {
        petriSpec: "specs.CallcenterLogs",
        default: false,
        description: "enables debug logs for callcenter",
        mergeJira: "TBD",
    },
    DisablePasswordForAgentInvitation: {
        petriSpec: "specs.DisablePasswordForAgentInvitation",
        default: false,
        description: "disables password for accept invitation for agent in login page",
        mergeJira: "https://app.asana.com/0/1200368299997249/1207372133141796/f",
    },
    AnswersDisableInternalLoginInHC: {
        petriSpec: "specs.AnswersDisableInternalLoginInHC",
        default: false,
        description: "hides login section for Users in login page",
        mergeJira: "FT is handled by server",
    },
    OneInboxChatStats: {
        petriSpec: "specs.OneInboxChatStats",
        default: false,
        description: "Enables Chat Stats in OI, requested by WIX",
        mergeJira: "TBD",
    },
    ShowOneInboxVideo: {
        petriSpec: "specs.ShowOneInboxVideo",
        default: false,
        description: "Shows one inbox video on first time usage",
        mergeJira: "https://jira.wixpress.com/browse/WA-15725",
    },
    OneInboxChatSoundNotification: {
        petriSpec: "specs.OneInboxChatSoundNotification",
        default: false,
        description: "Play sound notification when there is a new chat in One Inbox",
        mergeJira: "https://jira.wixpress.com/browse/WA-15985",
    },
    CustomerPortalSettings: {
        petriSpec: "specs.CustomerPortalSettings",
        default: false,
        description: "Customer portal settings",
        mergeJira: "https://jira.wixpress.com/browse/WA-15991",
    },
    OneInboxChatStatusFilter: {
        petriSpec: "specs.OneInboxChatStatusFilter",
        default: false,
        description: "add filter by chat status to OI",
        mergeJira: "https://jira.wixpress.com/browse/WA-15979",
    },
    CallCenterDashboard: {
        petriSpec: "specs.CallCenterDashboard",
        default: false,
        description: "Enables new Call Center Dashboard",
        mergeJira: "",
    },
    PaymentDetails: {
        petriSpec: "specs.PaymentDetails",
        default: false,
        description: "Enables Payment and Billing details",
        mergeJira: "https://jira.wixpress.com/browse/WA-16674",
    },
    WasabiCustomReports: {
        petriSpec: "specs.WasabiCustomReports",
        default: false,
        description: "enables WASABI custom reports",
        mergeJira: "https://jira.wixpress.com/browse/WA-16862",
    },
    LoggingACall: {
        petriSpec: "specs.LoggingACall",
        default: false,
        description: "Logging a Call feature for answers app (internal notes + custom fields)",
        mergeJira: "https://jira.wixpress.com/browse/WA-17013",
    },
    RealtimeTicketsPresence: {
        petriSpec: "specs.RealtimeTicketsPresence",
        default: false,
        description: "tickets RT presence",
        mergeJira: "https://jira.wixpress.com/browse/WA-17013",
    },
    HelpcenterSdkAddOnContactForm: {
        petriSpec: "specs.HCOnContactFormRender",
        default: false,
        description: "Adds onContactFormRendered method to Helpcenter sdk",
        mergeJira: "https://jira.wixpress.com/browse/WA-17127",
    },
    TwitterTicket: {
        petriSpec: "specs.TwitterTicket",
        default: false,
        description: "Twitter Ticket",
        mergeJira: "https://jira.wixpress.com/browse/WA-17295",
    },
    FourMillionBar: {
        petriSpec: "specs.FourMillionBar",
        default: false,
        description: "$4,000,000",
        mergeJira: "never",
    },
    SamlSsoLogin: {
        petriSpec: "specs.SamlSsoLogin",
        default: false,
        description: "Enables SAML SSO Login",
        mergeJira: "https://jira.wixpress.com/browse/WA-17393",
    },
    CsatConditions: {
        petriSpec: "specs.CsatConditions",
        default: false,
        description: "Adds CSAT conditions table to settings",
        mergeJira: "https://jira.wixpress.com/browse/WA-17715",
    },
    HelpcenterContactFormEmailConfirmation: {
        petriSpec: "specs.HelpcenterContactFormEmailConfirmation",
        default: false,
        description: "Adds email confirmation to helpcenter contact form",
        mergeJira: "https://jira.wixpress.com/browse/WA-17888",
    },
    MultipleLocalesViews: {
        petriSpec: "specs.MultipleLocalesViews",
        default: false,
        description: "support multiple locales in views",
        mergeJira: "https://jira.wixpress.com/browse/WA-17871",
    },
    PrivateViewsPermission: {
        petriSpec: "specs.PrivateViewsPermission",
        default: false,
        description: "Private views permission",
        mergeJira: "https://jira.wixpress.com/browse/WA-18241",
    },
    CallPriorityScoring: {
        petriSpec: "specs.CallPriorityScoring",
        default: false,
        description: "Enables features based on calls priority scoring",
        mergeJira: "https://jira.wixpress.com/browse/WA-18386",
    },
    MultiBrandTicketing: {
        petriSpec: "specs.MultiBrandTicketing",
        default: false,
        description: "enables multi brand ticketing",
        mergeJira: "https://app.asana.com/0/1201324221515916/1201370462400075/f",
    },
    SkipFiltersInUrl: {
        petriSpec: "specs.SkipFiltersInUrl",
        default: false,
        description: "Skip adding filters to URL parameters to avoid special character issues",
        mergeJira: "TBD",
    },
    MultiBrandTicketPermission: {
        petriSpec: "specs.MultiBrandTicketPermission",
        default: false,
        description: "add permission of change ticket name to roles and in UI",
        mergeJira: "https://app.asana.com/0/1200368299997249/1202104687796470/f",
    },
    EmailTemplatesAdditionalToggles: {
        petriSpec: "specs.EmailTemplatesAdditionalToggles",
        default: false,
        description: "Adds toggles to Ticket Replied and Resolved",
        mergeJira: "https://app.asana.com/0/1200368299997249/1201244034457393/f",
    },
    ReCaptchaV3: {
        petriSpec: "specs.ReCaptchaV3",
        default: false,
        description: "Upgrade to use ReCaptchaV3",
        mergeJira: "https://app.asana.com/0/1201324221515909/1201473019990380/f",
    },
    WidgetReCaptchaV3: {
        petriSpec: "specs.WidgetReCaptchaV3",
        default: false,
        description: "WidgetReCaptchaV3",
        mergeJira: "https://app.asana.com/0/1201047807369700/1201508256503815",
    },
    SchedulesLines: {
        petriSpec: "specs.SchedulesLines",
        default: false,
        description: "adds multiple schedule functionality to lines",
        mergeJira: "https://app.asana.com/0/1201324221515881/1201634249053405/f",
    },
    SubSubCategoriesSettings: {
        petriSpec: "specs.SubSubCategoriesSettings",
        default: false,
        description: "Enabled subsub-categories helpcenter settings changes",
        mergeJira: "https://app.asana.com/0/1201324221515895/1201899298987377/f",
    },
    LogMicrophonePermissions: {
        petriSpec: "specs.LogMicrophonePermissions",
        default: false,
        description: "Checks Agents microphone permission before accepting a call and logs it.",
        mergeJira: "N/A",
    },
    NewTicketModalMultiLevelCustomFields: {
        petriSpec: "specs.NewTicketModalMultiLevelCustomFields",
        default: false,
        description: "multi level custom fields in the new ticket modal",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202254670205839/f",
    },
    NewCategoriesPage: {
        petriSpec: "specs.NewCategoriesPage",
        default: false,
        description: "Enables new Categories page (app) with multi subcategory levels",
        mergeJira: "https://app.asana.com/0/1201623832157956/1202411487734945/f",
    },
    OneInboxAdvancedSearch: {
        petriSpec: "specs.OneInboxAdvancedSearch",
        default: false,
        description: "One inbox advanced search",
        mergeJira: "https://app.asana.com/0/1201146881163791/1202696257889712/f",
    },
    UseLibbyRenderHtmlInArticleViewer: {
        petriSpec: "specs.UseLibbyRenderHtmlInArticleViewer",
        default: false,
        description: "use libbys renderHTML",
        mergeJira: "",
    },
    CallbackRequestV2: {
        petriSpec: "specs.callBackRequestV2",
        default: false,
        description: "Enables the new answer-integrated calllback request modal",
        mergeJira: "",
    },
    VistaEscalation: {
        petriSpec: "specs.VistaEscalation",
        default: false,
        description: "Enables Ticket escalation for vista",
        mergeJira: "https://app.asana.com/0/1201146881163791/1203370987766246/f",
    },
    MasterIntegratorEscalation: {
        petriSpec: "specs.MasterIntegratorEscalation",
        default: false,
        description: "Enables Ticket escalation for Master Integrator",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205622073602901/f",
    },
    StaffingGroupTicketPage: {
        petriSpec: "specs.StaffingGroupTicketPage",
        default: false,
        description: "StaffingGroup - changes on ticket page",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204164181945230/f",
    },
    RemoveAssignToUserTicketPage: {
        petriSpec: "specs.RemoveAssignToUserTicketPage",
        default: false,
        description: "StaffingGroup - removes ability to assign tickets to Experts from the Ticket page footer",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204769812192736/f",
    },
    HideSendAndAssignToggle: {
        petriSpec: "specs.HideSendAndAssignToggle",
        default: false,
        description: "Hides the send and assign toggle in one inbox ticket page",
        mergeJira: "https://app.asana.com/0/1200368299997249/1204086669827947/f",
    },
    WixStudioNewTicketModal: {
        petriSpec: "specs.WixStudioNewTicketModal",
        default: false,
        description: "adds account and site selectorto new ticket modal",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204359813557345/f",
    },
    SiteSelectorNewTicketModal: {
        petriSpec: "specs.SiteSelectorNewTicketModal",
        default: false,
        description: "adds wix user site selector to new ticket modal",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204359813557345/f",
    },
    EnableAISummaryInSavedReplies: {
        petriSpec: "specs.EnableAISummaryInSavedReplies",
        default: false,
        description: "Enables AI summary in saved replies",
        mergeJira: "https://app.asana.com/0/1200368299997249/1204060089268300/f",
    },
    TwilioClientMinorVersion15: {
        petriSpec: "specs.TwilioClientMinorVersion15",
        default: false,
        description: "experimental",
    },
    CCDashboardGroupFilter: {
        petriSpec: "specs.CCDashboardGroupFilter",
        default: false,
        description: "Enables filter by group (and not by queue & locale) in callcenter dashboard",
        mergeJira: "https://app.asana.com/0/1201257251712332/1205075019912214/f",
    },
    ReplaceQueuesSpotterChanges: {
        petriSpec: "specs.ReplaceQueuesSpotterChanges",
        default: false,
        description: "Enables changes in Spotter related to replacement queues by groups",
        mergeJira: "https://app.asana.com/0/1201257251712332/1205149989487017/f",
    },
    ReplaceQueuesAdjustments: {
        petriSpec: "specs.ReplaceQueuesAdjustments",
        default: false,
        description: "Enables cross app adjustments related to replacement queues by groups",
        mergeJira: "https://app.asana.com/0/1201257251712332/1205149989487017/f",
    },
    BoContentSnippets: {
        petriSpec: "specs.BoContentSnippets",
        default: false,
        description: "Back office Content Snippets page",
        mergeJira: "https://app.asana.com/0/1200368299997249/1202282890597270/f",
    },
    StaffingGroupHeaderOI: {
        petriSpec: "specs.StaffingGroupHeaderOI",
        default: false,
        description: "staffing group for new ticket anf callback request",
        mergeJira: "https://app.asana.com/0/1200368299997249/1204159933208156/f",
    },
    OneInboxProductSkillsFilter: {
        petriSpec: "specs.OneInboxProductSkillsFilter",
        default: false,
        description: "adds product skills tickets filter to one inbox",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204359813557345/f",
    },
    WixStudioIndicationOI: {
        petriSpec: "specs.WixStudioIndicationOI",
        default: false,
        description: "new indication in ticket page for studio users",
        mergeJira: "https://app.asana.com/0/1201146881163791/1204950558532853/f",
    },
    EnableSkillPage: {
        petriSpec: "specs.EnableSkillPage",
        default: false,
        description: "new skill page",
        mergeJira: "https://app.asana.com/0/1201257251712332/1205263191002997",
    },
    EnablePriorityUserOI: {
        petriSpec: "specs.EnablePriorityUserOI",
        default: false,
        description: "new indication in ticket page for priority users",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205135466388230/f",
    },
    EndSessionAfterWrapup: {
        petriSpec: "specs.EndSessionAfterWrapup",
        default: false,
        description: "Apply changes in the wrapup flow, end session will happen automatically when wrapup time is over",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205202481637536/f",
    },
    B2bEscalation: {
        petriSpec: "specs.B2bEscalation",
        default: false,
        description: "Add B2B Escalation to tickets page.",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205739108065049/f"
    },
    StaffingGroupsCalls: {
        petriSpec: "specs.StaffingGroupsCalls",
        default: false,
        description: "Staffing Groups for Calls",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205584438065685/f"
    },
    ExpertToolkit: {
        petriSpec: "specs.ExpertToolkit",
        default: false,
        description: "Expert toolkit that will replace the side bar on ticket page",
        mergeJira: "https://app.asana.com/0/1201146881163791/1206257636673286/f"
    },
    WrapUpChats: {
        petriSpec: "specs.WrapUpChats",
        default: false,
        description: "wrap up for chat tickets",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205984218653749/f"
    },
    EnableSplitReplyPermissions: {
        petriSpec: "specs.EnableSplitReplyPermissions",
        default: false,
        description: "Split permissions modify/delete reply and note in Answers",
        mergeJira: "https://app.asana.com/0/1201146881163791/1205202481637536/f",
    },
    EnableNewChatDashboard: {
        petriSpec: "specs.EnableNewChatDashboard",
        default: false,
        description: "Replace chat dashboard with new",
        mergeJira: ""
    },
    GroupChatAvailability: {
        petriSpec: "specs.GroupChatAvailability",
        default: false,
        description: "Displays the option to set group chat availability",
        mergeJira: "https://app.asana.com/0/1201257251712332/1206440806037335/f",
    },
    SoftSkillsCallTransfer: {
        petriSpec: "specs.SoftSkillsCallTransfer",
        default: false,
        description: "Displays the language picker and the soft skill checkbox on call transfer flow",
        mergeJira: "https://app.asana.com/0/1201146881163791/1206497788441121/f",
    },
    NewCallCenterDashboard: {
        petriSpec: "specs.NewCallCenterDashboard",
        default: false,
        description: "New callcenter dashboard page",
        mergeJira: "",
    },
    NewChatAvailabilityAPI: {
        petriSpec: "specs.NewChatAvailabilityAPI",
        default: false,
        description: "Replaces Availability API form Chat transfers",
        mergeJira: "-",
    },
    SoftTransferRetry: {
        petriSpec: "specs.SoftTransferRetry",
        default: false,
        description: "Retry soft transfers",
        mergeJira: "-",
    },
    ToolkitQaPage: {
        petriSpec: "specs.ToolkitQaPage",
        default: false,
        description: "Enables QA Page in Toolkit",
        mergeJira: "-",
    },
    BlockAcceptCallWhenTimeOver: {
        petriSpec: "specs.BlockAcceptCallWhenTimeOver",
        default: false,
        description: "Block accept call when time to answer is over but the modal is still open",
        mergeJira: "https://app.asana.com/0/1201302116010542/1207350263065925/f",
    },
    ChatTransferAddSoftSkill: {
        petriSpec: "specs.ChatTransferAddSoftSkill",
        default: false,
        description: "Add soft skills to transfer chat popover",
        mergeJira: "https://app.asana.com/0/1207112286413058/1207467750039671/f",
    },
    NewChatNotificationNotFocused: {
        petriSpec: "specs.NewChatNotificationNotFocused",
        default: false,
        description: "Change in the condition for new chat notification messages to play.",
        mergeJira: "https://app.asana.com/0/1201146881163791/1207462116225931/f",
    },
    AllowSingleLiveChannel: {
        petriSpec: "specs.AllowSingleLiveChannel",
        default: false,
        description: "This FT allows users to activate only one live channel.",
        mergeJira: "https://app.asana.com/0/1205531358836299/1207832921416709/f"
    },
    WPRFeatureRequestsOptInColumn: {
        petriSpec: "specs.WPRFeatureRequestsOptInColumn",
        default: false,
        description: "Adds opt-in column to feature requests table",
        mergeJira: "https://app.asana.com/0/1201304164860715/1207714991026587/f"
    },
    ToolkitEscalationsPage: {
        petriSpec: "specs.ToolkitEscalationsPage",
        default: false,
        description: "Enables escalation form on the Toolkit",
        mergeJira: "https://app.asana.com/0/1205531358836299/1207861238538755/f"
    },
    ToolkitEscalationsPageToAll: {
        petriSpec: "specs.ToolkitEscalationsPageToAll",
        default: false,
        description: "Enables escalation form on the Toolkit to All experts",
        mergeJira: "https://app.asana.com/0/1205531358836299/1207861238538755/f"
    },
    TwilioSdkV2: {
        petriSpec: "specs.TwilioSdkV2",
        default: false,
        description: "Enables Twilio SDK V2 migration",
        mergeJira: "https://app.asana.com/0/1207696963388789/1207913442343063/f"
    },
    ExpertToolkitDomainsEscalation: {
        petriSpec: "specs.ExpertToolkitDomainsEscalation",
        default: false,
        description: "When this FT is ON, users can see the domain option during an escalation",
        mergeJira: "https://wix.atlassian.net/browse/CCR-5662"
    },
    EnableChatbotHistoryOnToolkit: {
        petriSpec: "specs.EnableChatbotHistoryOnToolkit",
        default: false,
        description: "Enables chatbot history on toolkit",
        mergeJira: "https://app.asana.com/0/1201302116010542/1207972116632402/f"
    },
    ReactPopoverMigration: {
        petriSpec: "specs.ReactPopoverMigration",
        default: false,
        description: "Enables the new reac-tiny-popover Popover migration",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6320"
    },
    AllowMultipleChatWrapups: {
        petriSpec: "specs.AllowMultipleChatWrapups",
        default: false,
        description: "Enables time aggregation on multiple chat wrapups",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6535"
    },
    hideInstagramFacebookWhatsappViewsFilters: {
        petriSpec: "specs.hideInstagramFacebookWhatsappViewsFilters",
        default: false,
        description: "hides instagram, facebook and whatsapp channels from one-inbox views filters",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6565"
    },
    CacheTwilioToken: {
        petriSpec: "specs.CacheTwilioToken",
        default: false,
        description: "Caches the Twilio token",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6562"
    },
    IncomingRequestFromNotifier: {
        petriSpec: "specs.IncomingRequestFromNotifier",
        default: false,
        description: "Enables incoming request from notifier",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7162"
    },
    PreciseTicketRequestCountdown: {
        petriSpec: "specs.PreciseTicketRequestCountdown",
        default: false,
        description: "When this FT is ON, countdown in the incoming ticket request modal is calculated according to the actual date mentioned on the ticket request",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7231"
    },
    ReadOnlyImpersonation: {
        petriSpec: "specs.ReadOnlyImpersonation",
        default: false,
        description: "Enables read-only/request for full-access impersonation",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6733"
    },
    SplitWebhookApiPermissions: {
        petriSpec: "specs.SplitWebhookApiPermissions",
        default: false,
        description: "Split Manage webhooks & API keys into 2 separate permissions Add Scheduling permissions",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7058"
    },
    EnableOpenIssueTicketStatus: {
        petriSpec: "specs.EnableOpenIssueTicketStatus",
        default: false,
        description: "Enables open issue ticket status",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7286"
    },
    BlockStartSessionOnPendingRounting: {
        petriSpec: "specs.BlockStartSessionOnPendingRounting",
        default: false,
        description: "Blocks accept ticket when the ticket is in pending routing",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6733"
    },
    AutoRoutingGetPendingAssignements: {
        petriSpec: "specs.AutoRoutingGetPendingAssignements",
        default: false,
        description: "Gets Auto routing get pending assignements on load",
        mergeJira: "https://wix.atlassian.net/browse/CCR-6733"
    },
    AutoRoutingReconnectModal: {
        petriSpec: "specs.AutoRoutingReconnectModal",
        default: false,
        description: "Enables Auto routing reconnect modal on error",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7356"
    },
    AskMicrophonePermissionsOnLoad: {
        petriSpec: "specs.AskMicrophonePermissionsOnLoad",
        default: false,
        description: "Ask microphone permissions on app load",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7232"
    },
    ToolkitScalableEscalationPage: {
        petriSpec: "specs.ToolkitScalableEscalationPage",
        default: false,
        description: "When this FT is On, we show the scalable escalation solution page instead of the POC escalation page.",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7568"
    },
    ReduceGetUserShortcutsCalls: {
        petriSpec: "specs.ReduceGetUserShortcutsCalls",
        default: false,
        description: "When this FT is ON, shortcut calls are being called when needed and not on component load.",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7500"
    },
    TriggerMissedFromIncomingTicket: {
        petriSpec: "specs.TriggerMissedFromIncomingTicket",
        default: false,
        description: "Trigger missed from incoming ticket",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7252"
    },
    CCPriorityTwoIndication: {
        petriSpec: "specs.CCPriorityTwoIndication",
        default: false,
        description: "When this FT is ON, a new ui of the priority indications will show to the users of one-inbox/expert toolkit",
        mergeJira: "https://wix.atlassian.net/browse/CCR-8797"
    },
    EnableEscalationWizard: {
        petriSpec: "specs.EnableEscalationWizard",
        default: false,
        description: "Enables the escalations wizard",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7536"
    },
    EnableToolkitPlans: {
        petriSpec: "specs.EnableToolkitPlans",
        default: false,
        description: "Enables issue page plans section",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7536"
    },
    BlockUnbabelForPriorityJa: {
        petriSpec: "specs.BlockUnbabelForPriorityJa",
        default: false,
        description: "Block Unbabel for priority JA",
        mergeJira: "https://wix.atlassian.net/browse/CCR-7536"
    },
    OneInboxSoftSkillsFilter: {
        petriSpec: "specs.OneInboxSoftSkillsFilter",
        default: false,
        description: "When this FT is ON, users can filter tickets by soft skills",
        mergeJira: "https://wix.atlassian.net/browse/CCR-8738"
    },
    PreviewArticles: {
        petriSpec: "specs.PreviewArticles",
        default: false,
        description: "Enables preview articles from editor",
        mergeJira: "https://wix.atlassian.net/browse/CCR-8316"
    },
    RuleActionSoftSkill: {
        petriSpec: "specs.RuleActionSoftSkill",
        default: false,
        description: "Adds Rule Action Soft Skills",
        mergeJira: "https://wix.atlassian.net/browse/CCR-8316"
    },
    AddUserSkillsOnTicketCreation: {
        petriSpec: "specs.AddUserSkillsOnTicketCreation",
        default: false,
        description: "Adds user skills on ticket and callback creation",
        mergeJira: "https://wix.atlassian.net/browse/CCR-9500"
    },
    PollingPendingAssignements: {
        petriSpec: "specs.PollingPendingAssignements",
        default: false,
        description: "PollingPendingAssignements",
        mergeJira: "-"
    },
    SkillsAutomation: {
        petriSpec: "specs.SkillsAutomation",
        default: false,
        description: "skills Automation of editing team members topics and skills with wix smart.",
        mergeJira: "https://wix.atlassian.net/browse/CCR-9573"
    },
    AutoRoutingPollingOnly: {
        petriSpec: "specs.AutoRoutingPollingOnly",
        default: false,
        description: "disable rt events and use polling only",
        mergeJira: "https://wix.atlassian.net/browse/CCR-9853"
    },
    EnableRefundChecker: {
        petriSpec: "specs.EnableRefundChecker",
        default: false,
        description: "Refund checker",
        mergeJira: "-"
    },
    EnableRefundableIcon: {
        petriSpec: "specs.EnableRefundableIcon",
        default: false,
        description: "Refundable icon",
        mergeJira: "-"
    },
    RefundEscalation: {
        petriSpec: "specs.RefundEscalation",
        default: false,
        description: "Adding escalation flow for refunds to assign to billings",
        mergeJira: "https://wix.atlassian.net/browse/CCR-10066"
    },
    ToolkitGetSubscriptions: {
        petriSpec: "specs.ToolkitGetSubscriptions",
        default: false,
        description: "ToolkitGetSubscriptions new RPC",
        mergeJira: "-"
    },
    removeFiltersFromOneInboxUrl: {
        petriSpec: "specs.removeFiltersFromOneInboxUrl",
        default: false,
        description: "removes filters from one inbox url",
        mergeJira: "https://wix.atlassian.net/browse/CCR-10175"
    },
    SingleLiveChannel: {
        petriSpec: "specs.SingleLiveChannel",
        default: false,
        description: "This FT allows users to activate only one live channel.",
        mergeJira: "https://wix.atlassian.net/browse/CCR-10655"
    },
    DeEscalationLabelSkillSync: {
        petriSpec: "specs.DeEscalationLabelSkillSync",
        default: false,
        description: "Automatically adds/removes the de-escalation skill when experts add/remove 'de-esc' labels to ensure proper ticket routing during de-escalation workflows",
        mergeJira: "https://wix.atlassian.net/browse/CCR-11111",
    }
};
//# sourceMappingURL=features.js.map